import React from 'react';
import { Text, grey600 } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';

import { localsMessages } from '../utility/getTemplateData';
let messages = localsMessages('buttons/partner');

const styles = StyleSheet.create({
  disclaimerWrapper: {
    maxWidth: 415,
    margin: '24px auto 0',
    '.ppvx_accordion__row': { border: 'none' },
  },
  disclaimer: {
    margin: 'auto',
  },
});

export default function VoucherFlowDisclaimer() {
  return (
    <div className={`voucher-disclaimer ${css(styles.disclaimerWrapper)}`}>
      <Text
        size="sm"
        style={{
          color: grey600,
        }}
        dangerouslySetInnerHTML={{
          __html: messages.voucher.legal,
        }}
      ></Text>
    </div>
  );
}
